import { useTranslation } from 'react-i18next'
import { Button } from './ui/Button'
import { Icon } from "@/components/ui/Icon";

interface ErrorScreenProps {
  error?: unknown
  resetError?: () => void
}

export function ErrorScreen({ error, resetError }: ErrorScreenProps) {
  const { t } = useTranslation()
  const message =
    error instanceof Error ? error.message : null

  return (
    <div
      className="bg-canvas"
      style={{
        display: 'flex',
        height: '100dvh',
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        fontFamily: 'var(--font-chrome)',
        userSelect: 'none',
      }}
    >
      <div
        style={{
          width: 44,
          height: 44,
          borderRadius: 12,
          background: 'var(--color-danger-bg)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--color-danger)',
        }}
      >
        <Icon name="warning" size={20} />
      </div>

      <div style={{ textAlign: 'center', maxWidth: 280 }}>
        <p
          className="text-ink"
          style={{
            fontSize: 14,
            fontWeight: 500,
            margin: '0 0 6px',
            letterSpacing: '-0.01em',
          }}
        >
          {t('errorScreen.title')}
        </p>
        <p
          className="text-muted"
          style={{
            fontSize: 12.5,
            margin: 0,
            lineHeight: 1.6,
          }}
        >
          {message ?? t('errorScreen.defaultMessage')}
        </p>
      </div>

      <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
        {resetError && (
          <Button
            variant="outline"
            size="sm"
            onClick={resetError}
          >
            {t('common.tryAgain')}
          </Button>
        )}
        <Button
          variant="secondary"
          size="sm"
          onClick={() => window.location.reload()}
        >
          {t('common.reload')}
        </Button>
      </div>
    </div>
  )
}
